// This file is part of InvenioRequests
// Copyright (C) 2023-2024 CERN.
//
// Invenio RDM Records is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

import React from "react";
import { Icon } from "semantic-ui-react";

export const AccessRequestIcon = () => (
  <Icon name="unlock alternate" className="neutral" />
);
export const CommunityInclusionIcon = () => <Icon name="plus" className="neutral" />;
export const CommunityInvitationIcon = () => (
  <Icon name="user plus" className="neutral" />
);
